import { createContext, useState } from "react";
import axiosClient from "../configs/axios-client";
import { toFormData } from "axios";
import { useTranslation } from "react-i18next";

export const ContentContext = createContext();

const ContentContextProvider = ({ children }) => {
  const { t, i18n } = useTranslation();

  const convertToObject = (data) =>
    data.reduce((acc, cv) => Object.assign({ [cv.key]: cv.translated_value }, acc), {});

  const fetchContent = (filter, setter) => {
    axiosClient
      .get("content", { params: { filter } })
      .then((res) => {
        const data = convertToObject(res.data.data);
        console.log(data)

        setter((prev) => Object.assign(data));
      })
      .catch((error) => {
        console.log(`got an error while fetching ${filter}`);
      });
  };
  const [hero, setHero] = useState({});
  function fetchHero() {
    fetchContent("hero", setHero);
  }

  const [about, setAbout] = useState({});
  function fetchAbout() {
    fetchContent("about", setAbout);
  }

  const [who, setWho] = useState({});
  function fetchWho() {
    fetchContent("who", setWho);
  }

  const [vision, setVision] = useState({});
  function fetchVision() {
    fetchContent("philosophy", setVision);
  }

  const [word, setWord] = useState({});
  function fetchWord() {
    fetchContent("word", setWord);
  }

  const [events, setEvents] = useState([]);
  const fetchEvents = () => {
    axiosClient
      .get("event/index")
      .then((res) => {
        setEvents(res.data.data);
      })
      .catch(() => {
        console.log(`got an error while fetching events`);
      });
  };

  const [projects, setProjects] = useState([]);
  const fetchProjects = () => {
    axiosClient
      .get("project/index")
      .then((res) => {
        setProjects(res.data.data);
      })
      .catch((error) => {
        console.log(`got an error while fetching projects`);
      });
  };

  const [news, setNews] = useState([]);
  const fetchNews = () => {
    axiosClient
      .get("news/index")
      .then((res) => {
        setNews((prev) => res.data.data);
      })
      .catch((error) => {
        console.log(`got an error while fetching news`);
      });
  };

  
  const [partners, setPartners] = useState([]);
  const fetchPartners = () => {
    axiosClient
      .get("arms/index")
      .then((res) => {
        setPartners(res.data.data);
      })
      .catch((error) => {
        console.log(`got an error while fetching news`);
      });
  };

  const SendContactUs = (contact) => {
  
   let formData = new FormData();
    toFormData(contact, formData)
  
    
    axiosClient.post('contact_us', formData).then((res) => {
      alert(t('Sent succesfully'));
      return res;
    }).catch(e => {
      alert(t('There is something wrong '));

        console.log()
      
    })
  }
  const value = {
    hero,
    fetchHero,
    about,
    fetchAbout,
    SendContactUs,
    who,
    fetchWho,
    vision,
    fetchVision,
    word,
    fetchWord,
    projects,
    fetchProjects,
    news,
    fetchNews,
    events,
    fetchEvents,
    partners,
    fetchPartners,
  };

  return (
    <ContentContext.Provider value={value}>{children}</ContentContext.Provider>
  );
};

export default ContentContextProvider;
